import Vue from "vue";
import OktaPlugin from "./plugins/okta"
import App from "./App.vue";
import router from "./router";
import store from "./store";
import api from "./api";
import Notifications from "vue-notification";
import VModal from "vue-js-modal";
import { VMoney } from 'v-money'
import "./plugins/tooltip";

Vue.config.productionTip = false;

Vue.use(Notifications);
Vue.use(VModal, { dialog: true });
declare global {
  interface String {
    formatMoney(): string;
  }
}

(String as any).prototype.formatMoney = function() {
  return Number(this)
    .toFixed(2)
    .replace(".", ",")
    .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.");
};

Vue.use(OktaPlugin, {
  issuer: process.env.VUE_APP_OKTA_ISSUER,
  clientId: process.env.VUE_APP_OKTA_CLIENT_ID,
  redirectUri: window.location.origin + "/login/callback",
  scopes: ["openid", "profile", "email"],
  pkce: true,
  dpop: true,
  tokenManager: {
    autoRenew: false,
    secure: true
  }
})

Vue.directive('money', VMoney);

new Vue({
  router,
  store,
  render: h => h(App),
  async beforeMount() {
    (window as any)._open = window.open;
    (window as any).open = (path: string) => {
      (window as any)._open(`${path}?token=${this.$store.state.token}`);
    };

    const isLogged = await (this.$root as any).isLoggedIn();

    if (
      !isLogged &&
      location.pathname !== "/" &&
      location.pathname !== "/login" &&
      location.pathname !== "/login/callback"
    ) {
      this.$router.push("/");
    }
  },
  methods: {
    localizeDatepicker($) {
      $.fn.datepicker.language["es"] = {
        days: [
          "Domingo",
          "Lunes",
          "Martes",
          "Miércoles",
          "Jueves",
          "Viernes",
          "Sábado"
        ],
        daysShort: ["Dom", "Lun", "Mar", "Mie", "Jue", "Vie", "Sab"],
        daysMin: ["Dom", "Lun", "Mar", "Mie", "Jue", "Vie", "Sab"],
        months: [
          "Enero",
          "Febrero",
          "Marzo",
          "Abril",
          "Mayo",
          "Junio",
          "Julio",
          "Agosto",
          "Septiembre",
          "Octubre",
          "Noviembre",
          "Diciembre"
        ],
        monthsShort: [
          "Ene",
          "Feb",
          "Mar",
          "Abr",
          "May",
          "Jun",
          "Jul",
          "Ago",
          "Sep",
          "Oct",
          "Nov",
          "Dic"
        ],
        today: "Hoy",
        clear: "Limpiar",
        dateFormat: "dd/mm/yyyy",
        timeFormat: "hh:ii aa",
        firstDay: 1
      };
    },
    notify(text: string, type: string = "success", title: string = "Atención") {
      this.$notify({
        group: "aon",
        title: title,
        text: text,
        type: type,
        duration: 5000
      });
    },
    tokenIsExpired(token: string) {
      const exp = JSON.parse(atob(token.split('.')[1])).exp;
      return Date.now() >= exp * 1000
    },
    async isLoggedIn() {
      const isAuthenticated = await this.$auth.isAuthenticated({ onExpiredToken: 'renew' });
      if(isAuthenticated && (this.$store.state.token && this.tokenIsExpired(this.$store.state.token))) this.$store.commit("logout");

      return (
        isAuthenticated && this.$store.state.token && this.$store.state.user.id
      );
    },
    async logout() {
      this.$store.commit("logout");
      await this.$auth.signOut({
        revokeAccessToken: true,
        revokeRefreshToken: true,
        clearTokensBeforeRedirect: true
      });
    },
    async _get(path: string, params: Record<string, any>) {
      return api
        .init(
          this.apiUrl,
          await this.$auth.getAccessToken(),
          this.$store.state.token,
          this.$router
        )
        .call("get", path, params);
    },
    async _getFile(path: string, params: Record<string, any>){
      return api
        .init(
          this.apiUrl, 
          await this.$auth.getAccessToken(),
          this.$store.state.token,
          this.$router
        )
        .callFile("get", path, params);
    },
    async _post(path: string, params: Record<string, any>) {
      return api
        .init(
          this.apiUrl, 
          await this.$auth.getAccessToken(),
          this.$store.state.token,
          this.$router
        )
        .call("post", path, params);
    },
    async _postFile(path: string, data: FormData) {
      return api
        .init(
          this.apiUrl,
          await this.$auth.getAccessToken(),
          this.$store.state.token,
          this.$router
        )
        .callFile("post", path, data);
    },
    async _delete(path: string, params: Record<string, any>) {
      return api
        .init(
          this.apiUrl,
          await this.$auth.getAccessToken(),
          this.$store.state.token,
          this.$router
        )
        .call("delete", path, params);
    },
    async _put(path: string, params: Record<string, any>) {
      return api
        .init(
          this.apiUrl,
          await this.$auth.getAccessToken(),
          this.$store.state.token,
          this.$router
        )
        .call("put", path, params);
    },
    async _patch(path: string, params: Record<string, any>) {
      return api
        .init(
          this.apiUrl,
          await this.$auth.getAccessToken(),
          this.$store.state.token,
          this.$router
        )
        .call("patch", path, params);
    }
  },
  computed: {
    apiUrl() {
      return process.env.VUE_APP_API_URL;
    }
  }
}).$mount("#app");
